const WALLET_ADDRESS = 'nasio_wallet_address';

export class WalletStorage {
  static setWalletAddress({ address }) {
    window.sessionStorage.setItem(WALLET_ADDRESS, JSON.stringify(address));
  }
  static getWalletAddress() {
    try {
      return JSON.parse(window.sessionStorage.getItem(WALLET_ADDRESS));
    } catch {
      return undefined;
    }
  }

  static clearWalletAddress() {
    window.sessionStorage.removeItem(WALLET_ADDRESS);
  }
}
